import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import Icon from 'carbon-react/lib/components/icon';

import { Consolidation } from '@futrli-sdk/consolidations';
import { FormattedMessage } from '@futrli/localisation';
import { getEditConsolidationUrl } from '@futrli/shared-services';
import { ListingPageRowActionItem } from '@futrli/ui-components/components/listing-page/listing-page-row/listing-page-row-actions/listing-page-row-actions';

import { useConsolidationsActions } from '../../context/consolidations-actions-context/consolidations-actions-context';

interface UseConsolidationActionItemsParams {
  consolidation: Consolidation;
}

export const useConsolidationActionItems = ({
  consolidation
}: UseConsolidationActionItemsParams): ListingPageRowActionItem[] => {
  const { handleDeleteConsolidationClick } = useConsolidationsActions();
  const navigate = useNavigate();

  return useMemo<ListingPageRowActionItem[]>(() => {
    const items: ListingPageRowActionItem[] = [];

    items.push({
      label: <FormattedMessage id="consolidation.consolidation_settings" defaultMessage="Consolidation settings" />,
      onClick: () => navigate(getEditConsolidationUrl(consolidation.workspace_id, consolidation.id))
    });

    items.push({
      label: (
        <>
          <Icon type="delete" fontSize="small" />
          <FormattedMessage id="common.delete" defaultMessage="Delete" />
        </>
      ),
      onClick: () => handleDeleteConsolidationClick(consolidation),
      variant: 'danger'
    });

    return items;
  }, [consolidation, handleDeleteConsolidationClick, navigate]);
};
